import { Customer } from "../../entities/Customer";
import { httpClient } from "../http/httpClient";

export interface createPublicCustomerBody {
  name: string;
  cpf: string;
  phone: string;
  email: string;
  leadId: string;
  rg: {
    number: string;
    uf: string;
    org: string;
    date: string;
  };
  birthDate: string;
  address: {
    zipCode: string;
    state: string;
    city: string;
    neighborhood: string;
    street: string;
    number: string;
    complement?: string;
  };
  bankAccount: {
    bank: string;
    agency: string;
    account: string;
    accountType: string;
  };
}

export interface PublicCustomerResponse extends Customer {}

export async function createPublicCustomer(body: createPublicCustomerBody) {
  const { data } = await httpClient
    .post<PublicCustomerResponse>("/self-hire/customer", body)
    .catch((err) => {
      throw err?.response?.data || err;
    });

  return data;
}
